import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Routes, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { CommonService } from './common/services/common.service';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomMatRangeService } from './shared/components/date-range/custom-mat-range.service';
import { QuickSearchService } from './shared/services/quick-search.service';
import { CustomDialogService } from './shared/components/info-toast/services/custom-dialog.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { ProgrammaticThemePreset, ThemeDarkModeKey } from './prime-design-tokens/programmatic-prime-preset.config';
import { IMAGE_CONFIG, registerLocaleData } from '@angular/common';
import { provideHighlightOptions } from 'ngx-highlightjs';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import localeRuExtra from '@angular/common/locales/extra/ru';
import localeRu from '@angular/common/locales/ru';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgxEchartsModule } from 'ngx-echarts';
import { PlatformRouterLinks } from './common/common.const';
import { SessionService } from './shared/services/session.service';
import { QueueHttpService } from './shared/services/http-quene.service';
import { authInterceptor } from './shared/services/auth.interceptor';
import { ChunkErrorHandler } from './shared/services/chunk-error.handler';

registerLocaleData(localeRu, 'ru-RU', localeRuExtra);

function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const routes: Routes = [
	{
		path: '',
		children: [],
		data: {
			skipUrl: true,
		},
	},
	{
		path: PlatformRouterLinks.mainLoggedPrefix,
		loadComponent: () => import('./shared/containers/layout/layout.component').then((m) => m.LayoutComponent),
		loadChildren: () => import('./base-routing-module.module').then((m) => m.BaseRoutingModuleModule),
	},
	{
		path: PlatformRouterLinks.login,
		loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
		data: {
			skipUrl: true,
		},
	},
	{
		path: PlatformRouterLinks.resetPassword,
		loadComponent: () =>
			import('./login/pages/change-password-page/change-password-page.component').then(
				(m) => m.ChangePasswordPageComponent,
			),
		data: {
			skipUrl: true,
		},
	},
	// TODO
	{
		path: 'doNotHavePermission',
		component: PageNotFoundComponent,
		data: {
			title: '403',
		},
	},
	// {
	// 	path: '**',
	// 	redirectTo: 'agency/pageNotFound',
	// },
	{
		path: 'agency/pageNotFound',
		component: PageNotFoundComponent,
		data: {
			title: '404',
			skipUrl: true,
		},
	},
];

export const appConfig: ApplicationConfig = {
	providers: [
		provideHttpClient(
			withInterceptors([
				authInterceptor, // новый интерсептор по бестпрактису ангуляра
				// ErrorsInterceptor TODO: надо переделать этот высер и добавить мессаджи по ошибкам
			]),
		),

		// использование QueueHttpService как HttpClient
		QueueHttpService,
		{ provide: HttpClient, useExisting: QueueHttpService },

		provideRouter(routes /*, withDebugTracing() */, withViewTransitions()),
		provideAnimationsAsync('animations'),
		provideZoneChangeDetection({ eventCoalescing: true }),

		importProvidersFrom([
			AngularSvgIconModule.forRoot(),
			NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
			TranslateModule.forRoot({
				loader: {
					provide: TranslateLoader,
					useFactory: HttpLoaderFactory,
					deps: [HttpClient],
				},
			}),
		]),
		providePrimeNG({
			theme: {
				preset: ProgrammaticThemePreset,
				options: {
					darkModeSelector: `.${ThemeDarkModeKey}`,
				},
			},
		}),
		provideHighlightOptions({
			fullLibraryLoader: () => import('highlight.js'),
			lineNumbersLoader: () => import('ngx-highlightjs/line-numbers'),
		}),

		SessionService,
		{ provide: ErrorHandler, useClass: ChunkErrorHandler },

		{ provide: DateAdapter, useClass: CustomMatRangeService },
		CommonService,
		QuickSearchService,
		CustomDialogService,
		ConfirmationService,
		MessageService,
		{ provide: MAT_DATE_LOCALE, useValue: 'ru-RU' },
		{
			provide: IMAGE_CONFIG,
			useValue: { disableImageSizeWarning: true, disableImageLazyLoadWarning: true },
		},
	],
};
